import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import formatRecipientList from "../util/formatRecipientList";

export default function RecipientListLabel(props) {
  const [showAllParticipants, setShowAllParticipants] = useState(false);

  const handleClick = () => {
    setShowAllParticipants(!showAllParticipants);
  };

  const displaySomeParticipants = () => {
    return (
      <div>
        <div>
          {props.participants.length > 0 ? (
            <>
              <span className="font-bold mr-2">
                <FormattedMessage
                  id="app.recipientListLabel.to"
                  defaultMessage="To:"
                />
              </span>
              <span>{formatRecipientList(props.participants)}</span>
            </>
          ) : (
            <FormattedMessage
              id="app.recipientListLabel.noRecipients"
              defaultMessage="No recipients found."
            />
          )}
          {props.participants.length > 1 && (
            <a
              href="javascript:;"
              className="btn btn-link ml-2 text-blue-700 underline"
              onClick={handleClick}
            >
              <FormattedMessage
                id="app.recipientListLabel.showMore"
                defaultMessage="Show More"
              />
            </a>
          )}
        </div>
      </div>
    );
  };

  const displayAllParticipants = () => {
    const paxLength = props.participants.length;
    return (
      <div style={{ maxHeight: "200px", overflowY: "scroll" }}>
        <span className="font-bold mr-2">
          <FormattedMessage
            id="app.recipientListLabel.to"
            defaultMessage="To:"
          />
        </span>
        {props.participants.map((item, i) => {
          return (
            <>
              <span>{item.displayName}</span>
              {i + 1 !== paxLength && <span>; </span>}
            </>
          );
        })}
        <a
          href="javascript:;"
          className="btn btn-link ml-2 text-blue-700 underline"
          onClick={handleClick}
        >
          <FormattedMessage
            id="app.recipientListLabel.showLess"
            defaultMessage="Show Less"
          />
        </a>
      </div>
    );
  };

  return (
    <div className="flex">
      {!props.participants.length > 0 && `No recipients found.`}
      {showAllParticipants
        ? displayAllParticipants()
        : displaySomeParticipants()}
    </div>
  );
}
